import { genericService } from "./genericService";

function getAllProvince(country) {
  return genericService.get("Province/ListAllProvince/" + country);
}

export const provinceService = {
  getAllProvince,
};
